module.exports = __webpack_public_path__ + "0cf9cd4f2b325938ffec68553ed5416d.jpg";